<script setup lang="ts">
import type { CmsElementHeadlineTwoRowImageText } from "@/composables/useCustom";
const props = defineProps<{
  content: CmsElementHeadlineTwoRowImageText;
}>();
const { headlineText, Rows: rowsData } = props.content.data;
const rows = computed(() => rowsData || []);
const getImage = ({ leftImage, rightImage }: any) => leftImage || rightImage;
</script>
<template>
  <div class="cust-2-col bg-c-light-grey px-4">
    <div class="container mx-auto relative py-14 sm:py-24">
      <div
        v-if="headlineText"
        class="title text-left md:text-center text-dark-bg font-bold mb-8 sm:mb-16"
      >
        <h3 class="text-2xl md:text-3xl lg:text-4xl">{{ headlineText }}</h3>
      </div>

      <div
        v-if="rows.length"
        v-for="(row, index) in rows"
        :key="index"
        :class="[
          'col-wrap flex flex-wrap md:flex-nowrap flex-col items-center justify-between',
          index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse',
          index !== rows.length - 1 ? 'mb-10 sm:mb-24' : '',
        ]"
      >
        <!-- Text Section -->
        <div
          class="w-full md:w-3/5 lg:w-[590px] p-0 mb-8 md:mb-0 text-dark-bg space-y-4"
          :class="{ 'md:pr-4': index % 2 === 0, 'sm:pl-4': index % 2 !== 0 }"
        >
          <h5 v-if="row.rowTitle" class="font-bold">
            {{ row.rowTitle }}
          </h5>
          <h6
            v-if="row.rowText"
            v-html="row.rowText"
            class="font-medium leading-normal"
          ></h6>
        </div>

        <!-- Image Section -->
        <div class="w-full md:w-2/5 lg:w-[488px]">
          <figure>
            <NuxtImg
              :src="getImage(row)?.media?.url"
              :alt="getImage(row)?.media?.alt"
              class="w-full h-auto object-cover rounded-lg aspect-[6/4]"
              :width="getImage(row)?.media?.metaData.width"
              :height="getImage(row)?.media?.metaData.height"
            />
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
